import { InputProps } from 'antd/lib/input/Input';
import React, { PureComponent, RefObject } from 'react';
import { Input } from 'antd';
import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';

interface TextFilterInputProps extends InputProps {
    value: string;
    onTextFilterChange(textFilter: string): void;
    hidePrefix?: boolean;

    // @ts-ignore
    inputRef?: RefObject<Input>;
}

export class TextFilterInput extends PureComponent<TextFilterInputProps> {
    handleReset = () => this.props.onTextFilterChange('');

    handleChange = e => this.props.onTextFilterChange(e.currentTarget.value);

    render() {
        const { value, onChange, onTextFilterChange, hidePrefix, inputRef, ...otherProps } = this.props;
        return (
            <Input
                className="search-field"
                value={value}
                prefix={hidePrefix ? null : <SearchOutlined />}
                suffix={<CloseCircleOutlined onClick={this.handleReset} />}
                onChange={this.handleChange}
                ref={inputRef}
                {...otherProps}
            />
        );
    }
}
